import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers/rootReducer";
import rootSaga from "./sagas/rootSaga";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { setProfileStore } from "./selectors/profileSelectors";

const persistConfig = {
  key: "root",
  storage,
  whitelist:['candidateReducer','configTimeSheetReducer','profileReducer']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Mount it on the Store
const store = createStore(persistedReducer, applyMiddleware(sagaMiddleware));
setProfileStore(store);

// Create the persistor
const persistor = persistStore(store);

// Then run the saga
sagaMiddleware.run(rootSaga);

export const getAuthToken = () => {
  try {
    const state = store.getState();
    return state.authReducer?.user?.authToken;
  } catch {}
};

export { persistor };

export default store;
